import { BiLogger } from '../../components/Hoc/BiLogger/BiLoggerProvider';
import { OnPaymentMethodSelectedInApplePay } from '../../types/ExternalContract';
import { BillingContactRestricted } from '../../types/BillingContact';
import { logGeneralError } from '../../utils/sentry';
import { getRestrictedContact, transformPaymentBreakdownToApplePay } from './applePayDataMapper';

interface OnPaymentMethodSelectedInApplePayParams {
  billingContact?: BillingContactRestricted;
}
export const paymentMethodSelectedHandler =
  (
    consumerCallback: OnPaymentMethodSelectedInApplePay,
    data: { paymentLabel: string; appInstanceId: string; currencyCode: string },
    _biLogger: BiLogger,
  ) =>
  async (event: ApplePayJS.ApplePayPaymentMethodSelectedEvent) => {
    try {
      const params: OnPaymentMethodSelectedInApplePayParams = {};
      if (event.paymentMethod.billingContact) {
        params.billingContact = getRestrictedContact(event.paymentMethod.billingContact);
      }
      const response = await consumerCallback(params);
      const { paymentAmount, paymentBreakdown } = response;
      const newTotal = { label: data.paymentLabel, amount: paymentAmount };
      const newLineItems = transformPaymentBreakdownToApplePay(paymentBreakdown);

      return {
        newTotal,
        newLineItems,
      };
    } catch (e) {
      logGeneralError({
        message: 'OnPaymentMethodSelectedInApplePay throws',
        payload: e,
      });
      throw e;
    }
  };
